import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { createElement } from 'inferno-create-element';
import { utils } from 'inferno-animation';
var addClassName = utils.addClassName,
    removeClassName = utils.removeClassName,
    registerTransitionListener = utils.registerTransitionListener,
    forceReflow = utils.forceReflow,
    setDisplay = utils.setDisplay;
/**
 * These are the open and close animation helpers
 */

export function animateModalOnRemove(node, callback) {
  var clone = node.cloneNode(true);
  setDisplay(node, 'none !important');
  node.parentNode.appendChild(clone);
  registerTransitionListener(clone, function () {
    // *** Cleanup ***
    callback && callback(clone);
    clone.remove();
  });
  setTimeout(function () {
    removeClassName(clone, 'show');
  }, 5);
}
export function animateModalOnAdd(node, callback) {
  setDisplay(node, 'none');
  addClassName(node, 'fade');
  forceReflow(node);
  setDisplay(node, 'block');
  registerTransitionListener([node, node.children[0]], function () {
    // *** Cleanup ***
    callback && callback(node);
  });
  addClassName(node, 'show');
}
export function Animated(props) {
  var Tag = props.tag,
      children = props.children,
      attrs = _objectWithoutProperties(props, ["tag", "children"]);

  return createElement(Tag || 'div', attrs, children);
}